import { render } from "./FuneralKioskFormType1.vue?vue&type=template&id=309b3bf4&lang=true"
import script from "./FuneralKioskFormType1.vue?vue&type=script&lang=js"
export * from "./FuneralKioskFormType1.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__